import { ViewSettings } from 'ontime-types';

export const viewsSettingsPlaceholder: ViewSettings = {
  dangerColor: '#ff7300',
  normalColor: '#ffffffcc',
  overrideStyles: false,
  warningColor: '#ffa528',
};
